/**
 * Le mixin ngContect permet d'aller choper le context angular qui est toujours stocker a la racine du context vuejs.
 * On peut toujour faire un this.$root.$data.ngContext() pour aller le choper, mais ce mixin ajoute une fonction helper qui perset
 *  - Soit que choper le context sans entrer tout le path (this.ngCOnetxt() => context)
 *  - Soit de wraper le ngContext dansun callback (avec un call automatique du scope.apply une fois le cb executé)
 */

export default {
    methods: {
        /**
         * Sans callback ça retourne un objet avec $scope, $element et $injector (il faut bien fait un scope.apply après)
         * Si on passe un callback (async ou pas), ça call le callback avec le même object en param (scope, $element, injector) et ça call automatiquement $scope.$apply a la fin.
         * @param cb 
         * @returns 
         */
        ngContext(cb) {
            if (!cb) {
                return this.$root.$data.ngContext()
            }

            const { $scope } = this.$root.$data.ngContext();
            return new Promise(async (resolve, reject) => {
                try {
                    resolve(await cb(this.$root.$data.ngContext()))
                } catch (e) {
                    reject(e)
                }
            }).then(value => {
                $scope.$apply();
                return value
            })


        }
    }
}